/*
 * 接口统一集成模块
 */
import * as accessory from './common/accessory'
import * as commonRemark from './common/remark'
import * as upload from './common/upload'
import * as login from './admin/login'
import * as user from './admin/user'
import * as dept from './admin/dept'
import * as role from './admin/role'
import * as menu from './admin/menu'
import * as advertise from './cms/advertise'
import * as market from './cms/market'
import * as member from './app/member'
import * as level from './app/level'
import * as category from './pms/category'
import * as game from './pms/game'
import * as ranking from './pms/ranking'
import * as playapply from './play/playapply'
import * as playlist from './play/playlist'
import * as playtop from './play/playtop'
import * as appraise from './play/appraise'
import * as serviceapply from './play/serviceapply'
import * as recommend from './play/recommend'
import * as balanceFlow from './play/balanceFlow'
import * as apply from './withdraw/apply'
import * as record from './withdraw/record'
import * as fail from './withdraw/fail'
import * as order from './oms/order'
import * as disOrder from './oms/disOrder'
import * as feedback from './other/feedback'
import * as userAgreement from './userAgreement/index'


// 默认全部导出
export default {
    //common模块
    upload,
    accessory,
    commonRemark,

    //admin模块
    login,
    user,
    dept,
    role,
    menu,

    //cms模块
    advertise,
    market,

    //app模块
    member,
    level,

    //pms模块
    category,
    game,
    ranking,
    
    //play模块
    playapply,
    serviceapply,
    playlist,
    recommend,
    balanceFlow,
    appraise,
    playtop,

    //withdraw模块
    apply,
    record,
    fail,

    //oms模块
    order,
    disOrder,

    //意见反馈
    feedback,

    //用户协议
    userAgreement,
}



// WEBPACK FOOTER //
// ./src/http/api.js